import React, { useEffect, useState } from "react";
// import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { Divider, useMediaQuery } from "@mui/material";
import { Title, YouTube } from "@mui/icons-material";
import { FaInstagram, FaYoutube } from "react-icons/fa";
import { FaFacebook, FaTwitter, FaXTwitter } from "react-icons/fa6";
import { ArrowBack } from "@mui/icons-material"; // Import back arrow icon
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  featuredJobs,
  getFeatureType,
  show_proper_words,
} from "../../../utils/Constant";
import { s3baseUri } from "../../../config/config";
import { useIds } from "../../../hook/AdminContext";
import { enqueueSnackbar } from "notistack";
import ReactPlayer from "react-player";
import PageLoading from "../../../components/loader/PageLoading";
import { Calendar, Clock, Eye, Mic } from "lucide-react";
import {
  blog_view_count_increase,
  details_blog,
} from "../../../DAL/blogs/BlogList";
import {
  podcast_details,
  podcast_play_count_increase,
} from "../../../DAL/podcast/podcast";
import DocumentPreview from "../../DocumentPreview/previewDocument";

export default function BlogDetail() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const state = useLocation();
  const location = useLocation();
  const { userInfo } = useIds();
  const { findId, setBreadCrumb } = useIds();
  const [dataapi, setDataApi] = useState();
  const [loading, setLoading] = useState(false);

  const params = useParams();
  const { source_slug, feature_slug, blog_type, blog_slug } = params;

  const firstSegment = location.pathname.split("/")[1];
  const naviGatepathBack = location.pathname.includes("detail-blog-inside");

  const [data, setData] = useState(state?.state?.blog || null);

  const tab = state.state?.tab;

  const fetchDetailsOfBlog0rPodcast = async () => {
    setLoading(true);
    const resp =
      blog_type == "podcast-details"
        ? await podcast_details(blog_slug)
        : await details_blog(blog_slug);
    console.log(resp, "resp,resp,resp,resp,");

    if (resp.code == 200) {
      if (blog_type == "podcast-details") {
        setData(resp.podcast_blog);
      } else {
        setData(resp.blog);
      }
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetailsOfBlog0rPodcast();
  }, []);
  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${params?.source_slug}/home`,
        active: false,
      },
      {
        name: `Feature Category`,
        path: params?.category_slug
          ? `/${params?.source_slug}/feature/${params?.feature_slug}/${params?.category_slug}`
          : `/${params?.source_slug}/feature/${params?.feature_slug}${
              tab ? `?tab=${tab}` : ""
            }`,
        active: false,
      },

      {
        name: `Blog Detail`,
        path: ``,
        active: true,
      },
    ]);
  }, []);

  const docs = data?.documents?.map((docPath) => ({
    uri:
      typeof docPath === "string" && docPath.startsWith("http")
        ? docPath
        : s3baseUri + docPath,
  }));

  useEffect(() => {
    if (blog_type == "insight-details") {
      if (data?.client_object?._id !== userInfo.profile_id) {
        blog_view_count_increase(data?._id);
      }
    }
    if (blog_type == "podcast-details") {
      podcast_play_count_increase(data?._id);
    }
  }, [data?._id]);

  if (loading) {
    return <PageLoading />;
  }

  return (
    <div className="container-fluid justify-content-center mt-3">
      <div className="card-1 shadow-md p-4 mt-3 mb-4 about-content">
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-mb-4">
          {data?.category[0]?.title && (
            <span className="job-blue-chip">{data?.category[0]?.title}</span>
          )}
          {data?.createdAt && (
            <div className="tw-flex tw-items-center tw-text-sm">
              <Calendar className="tw-h-4 tw-w-4 tw-mr-1" />
              <span>{new Date(data?.createdAt).toLocaleDateString()}</span>
            </div>
          )}
          {(data?.read_time || data?.duration) && (
            <div className="tw-flex tw-items-center tw-text-sm">
              <Clock className="tw-h-4 tw-w-4 tw-mr-1" />
              <span>{data?.read_time || data?.duration}</span>
            </div>
          )}

          {data?.writer && (
            <div className="tw-flex tw-items-center tw-text-sm">
              <span>By: {data?.writer}</span>
            </div>
          )}
          {data?.play_count ? (
            <div className="tw-flex tw-items-center tw-text-sm">
              <Mic className="tw-h-4 tw-w-4 tw-mr-1" />
              <span>{data?.play_count}</span>
            </div>
          ) : (
            ""
          )}

          {data?.view_count ? (
            <div className="tw-flex tw-items-center tw-mt-1 sm:tw-mt-0 sm:tw-ms-4">
              <Eye className="tw-h-4 tw-w-4 tw-mr-1" />
              <span>{data?.view_count}</span>
            </div>
          ) : (
            ""
          )}
        </div>
        <h4 className="mb-2">{data?.title}</h4>
        <p>{data?.short_description || data?.podcast_name}</p>
        {/* Wrap media and content inside same parent div */}
        <div className="">
          <div className="media-wrapper mb-4">
            {data?.video_url && data?.video_url !== "" ? (
              <ReactPlayer
                url={data?.video_url}
                controls
                width="100%" // react player container ko 100% de diya
                height="450px" // thodi height kam kari
                style={{ maxWidth: "600px", margin: "0 auto" }}
              />
            ) : (
              <img
                src={
                  data?.image[0]?.thumbnail_3
                    ? s3baseUri + data?.image[0]?.thumbnail_3
                    : s3baseUri + data?.image[0]?.thumbnail_1
                }
                alt="Blog"
                className="banner-image"
              />
            )}
          </div>

          <div
            className="editor-content"
            dangerouslySetInnerHTML={{
              __html: data?.description,
            }}
          ></div>
        </div>
        {docs?.length > 0 && (
          <div className="documents-preview mt-4">
            <h5>Documents </h5>
            <DocumentPreview files={docs} data={data} />
          </div>
        )}
      </div>
    </div>
  );
}
